<template>
  <div v-for="n in skeletonCards" :key="n">
    <div
      class="bg-[#FFFFFF] rounded-[16px]"
      data-testid="skeleton-card-contents"
    >
      <div class="p-[8px] md:p-[16px]">
        <USkeleton
          class="aspect-[16/9] border-[1px] border-solid border-[#f7f7f7]"
          :ui="{
            base: 'animate-pulse round-[8px] bg-gradient-to-r from-[#DEDEDE] to-[#F7F7F7]',
          }"
        />
        <USkeleton
          class="h-[10px] mt-[8px] md:mt-[16px]"
          :ui="{
            base: 'animate-pulse round-[16px] bg-gradient-to-r from-[#DEDEDE] to-[#F7F7F7]',
          }"
        />
        <USkeleton
          class="h-[10px] w-[70%] mt-[8px]"
          :ui="{
            base: 'animate-pulse round-[8px] bg-gradient-to-r from-[#DEDEDE] to-[#F7F7F7]',
          }"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps({
  skeletonCards: {
    type: Number,
    default: 6,
  },
});
</script>
